import axios from "@/api/axiosInstance";

export function fetchSent(pageNumber) {
  return axios.get(`/api/v1/sent?page=${pageNumber}`);
}

export function deleteSent(payload) {
  return axios.delete(`/api/v1/sent/${payload}`);
}
